'use client';
import { _ as _extends, a as _object_without_properties_loose } from './cc-zJdVkWBV.js';
import { jsx } from 'react/jsx-runtime';
import { onLoad } from '@repo/lib';
import { getImageProps } from 'next/image';

function Image(_0) {
    let props = _extends({}, _0);
    var _props_alt;
    let { placeholder } = props;
    const { blurDataURL, style } = props;
    if (blurDataURL) {
        placeholder = "blur";
    }
    const _getImageProps = getImageProps(_extends({}, props, {
        alt: (_props_alt = props.alt) != null ? _props_alt : "",
        placeholder
    })), { props: _ref } = _getImageProps, { style: imgStyle } = _ref, imgProps = _object_without_properties_loose(_ref, [
        "style"
    ]);
    return /*#__PURE__*/ jsx("img", _extends({}, imgProps, {
        style: _extends({}, imgStyle, style),
        fetchPriority: props.preload ? "high" : "auto",
        onLoad: (event)=>{
            var _props_delay;
            const img = event.currentTarget;
            setTimeout(()=>{
                onLoad(img);
            }, (_props_delay = props.delay) != null ? _props_delay : 0);
            if (props.onLoad) {
                props.onLoad(event);
            }
        }
    }));
}

export { Image };
